

import { CheckboxVisibility, DetailsList, Dropdown, IColumn, IContextualMenuItem, IDetailsRowProps, Label, PrimaryButton, SearchBox, Stack, TextField } from '@fluentui/react';
import * as React from 'react'
import { useTranslation } from 'react-i18next';
import Paging from '../../../control/paging'
import useToken from '../../account/login/useToken';
import * as Api from '../../../api/src'
import { _renderRow } from '../../../control/function/detailList'
import '../../../css/controll/buttonMenuContext.scss'
import { API } from '@sentry/core';
import { LeftMenuContext } from '../../../context/leftMenu.context';
import globalData from '../../../common/globalData';
import { ToastAppType } from '../../../common/constant/enum/toastAppType';
import { ToastAppMsgContext } from '../../../context/toastApp.Context';
const ConfigurationsApi = new Api.SystemConfigsApi();
const Configurations = () => {
    const { } = useToken();
    const { t } = useTranslation();
    const { setSelectedMenuItem } = React.useContext(LeftMenuContext);
    const [idShowFrom, setIsShowFrom] = React.useState<boolean>(false);
    const [listWarringForOverdue, setListWarringForOverdue] = React.useState<any[]>([]);
    const [listOverdueNotification, setListOverdueNotification] = React.useState<any[]>([
        { key: Api.OverdueNotificationEnum.PushNotificationAndSendEmail, text: t('PushNotificationSendEmail') },
        { key: Api.OverdueNotificationEnum.PushNotification, text: t('PushNotification') },
        { key: Api.OverdueNotificationEnum.SendEmail, text: t('SendEmail') },
        { key: Api.OverdueNotificationEnum.DoNotApply, text: t('DoNotApply') }
    ]);
    const [listModuleFollowTestApprovedEnum, setListModuleFollowTestApprovedEnum] = React.useState<any[]>([
        { key: Api.ModuleFollowTestApprovedEnum.NotApplicable, text: t('NotApplicable') },
        { key: Api.ModuleFollowTestApprovedEnum.Follow, text: t('Follow') },
    ]);
    const [EditConfigurationCommand, setEditConfigurationCommand] = React.useState<Api.EditSystemConfigCommand>({
        ModuleFollowTestApproved: Api.ModuleFollowTestApprovedEnum.NotApplicable,
        OverdueNotification: Api.OverdueNotificationEnum.PushNotificationAndSendEmail,
        WarningOverdueDays: 5
    });
    const { setToastData } = React.useContext(ToastAppMsgContext);
    React.useEffect(() => {
        setSelectedMenuItem("Configurations")
        getListWarringForOverdue();
        getData()
    }, []);
    const getData = () => {
        ConfigurationsApi.apiSystemConfigsGet().then((res) => {
            if (res.data.Data) {
                let data = res.data.Data
                setEditConfigurationCommand({
                    ModuleFollowTestApproved: data.ModuleFollowTestApproved,
                    OverdueNotification: data.OverdueNotification,
                    WarningOverdueDays: data.WarningOverdueDays
                });
                globalData.Configurations = res.data.Data;
            }
            setIsShowFrom(true);
        });
    }
    const getListWarringForOverdue = () => {
        let list = [];
        for (let index = 1; index <= 14; index++) {
            list.push({ key: index, text: t("Before_Day").replace('{0}', index.toString()) })
        }
        list.push({ key: 0, text: t('DoNotApply') });
        setListWarringForOverdue(list);
    }
    const saveSettings = () => {
        ConfigurationsApi.apiSystemConfigsPost(EditConfigurationCommand).then((data) => {
            getData();
            setToastData({ Message: t("Successed"), Type: ToastAppType.Success });
        });
    }
    return (
        <>
            {idShowFrom && (
                <>
                    <div className={"page-header"}><Label>{t("Configurations")}</Label></div>
                    <div className="page-content ms-Grid" dir="ltr">
                        <div className={"ms-Grid-row flex-center"}>
                            <div className="ms-Grid-col margin-left-auto">
                                <PrimaryButton onClick={() => {
                                    saveSettings();
                                }}>{t("SaveSettings")}</PrimaryButton>
                            </div>
                        </div>
                        <div className={"ms-Grid-row flex-center"}>
                            <div className="ms-Grid-col ms-md9">
                                <div><Label>{t("WarringForOverdue")}</Label></div>
                                <div>{t("SetTheWarningDayAhead")}</div>
                            </div>
                            <div className="ms-Grid-col ms-md3">
                                <Dropdown options={listWarringForOverdue} selectedKey={EditConfigurationCommand.WarningOverdueDays} onChange={(ev, option) => {
                                    if (option?.key || option?.key === 0) {
                                        setEditConfigurationCommand({ ...EditConfigurationCommand, WarningOverdueDays: (option?.key) as number })
                                    }
                                }} ></Dropdown>
                            </div>
                        </div>
                        <div className={"ms-Grid-row flex-center"}>
                            <div className="ms-Grid-col ms-md9">
                                <div><Label>{t("OverdueNotification")}</Label></div>
                                <div>{t("PushNotificationOrSendEmailOnTheDeadline")}</div>
                            </div>
                            <div className="ms-Grid-col ms-md3">
                                <Dropdown options={listOverdueNotification} selectedKey={EditConfigurationCommand.OverdueNotification} onChange={(ev, option) => {
                                    if (option?.key) {
                                        setEditConfigurationCommand({ ...EditConfigurationCommand, OverdueNotification: option?.key as Api.OverdueNotificationEnum })
                                    }
                                }}></Dropdown>
                            </div>
                        </div>
                        <div className={"ms-Grid-row flex-center"}>
                            <div className="ms-Grid-col ms-md9">
                                <div><Label>{t("ModuleStatusFollowsTestStatus")}</Label></div>
                                <div>{t("WhenATestIsApprovedTheRelavantModuleWillBeApproved")}</div>
                            </div>
                            <div className="ms-Grid-col ms-md3">
                                <Dropdown options={listModuleFollowTestApprovedEnum} selectedKey={EditConfigurationCommand.ModuleFollowTestApproved} onChange={(ev, option) => {
                                    if (option?.key) {
                                        setEditConfigurationCommand({ ...EditConfigurationCommand, ModuleFollowTestApproved: option?.key as Api.ModuleFollowTestApprovedEnum })
                                    }
                                }}></Dropdown>
                            </div>
                        </div>
                    </div>

                </>
            )}
        </>
    );
}
export default Configurations;


